<template>
  <v-group :config="{ ...printAreaConfig }">
    <v-group :config="{ x: printAreaOffsetX }">
      <v-group :config="{ ...clippingMaskConfig, fillPatternImage: null }">
        <artwork
          v-if="artwork"
          :artwork="artwork"
          :width="artworkWidth"
          :height="printAreaConfig.height"
          :parentRatio="ratio"
          :name_layer="name_layer"
          :offset="{
            x: printAreaConfig.x + printAreaOffsetX,
            y: printAreaConfig.y,
            offsetX: printAreaOffsetX
          }"
          :rotation="printAreaConfig.rotation"
        />
      </v-group>
    </v-group>
  </v-group>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import ArtworkPreview from "./ArtworkPreview";

import { get, map, pick, concat } from 'lodash'
export default {
  name: "PrintAreaPreview",
  components: {
    artwork: ArtworkPreview
  },
  props: {
    layer: {
      type: Object
    },
    ratio: {
      type: Number,
      default() {
        return 1
      }
    },
    name_layer: {
      type: String,
      default() {
        return '';
      }
    },
    scaleDom: {
      type: Number,
      default(){
        return 7.7
      }
    }
  },
  data() {
    return {
      artwork: null,
      printAreaOffsetX: 0
    }
  },
  mounted() {
    const { layer, artworks, variants = [] } = this
    concat(...variants.map(v => v.print_areas)).forEach(printArea => {
      if (printArea.product_type_print_area_id === layer.printArea.id) {
        this.artwork = artworks.find(a => a.id === printArea.artwork_id);
      }
    })
    this.updatePreview()
  },
  computed: {
    ...mapGetters([
      'variants',
      'artworks',
      'personalized',
      'variantMockups',
      'printAreas',
      'ratios',
      'artworkPreviews',
      'loadings',
      'product'
    ]),
    layers() {
      const template = get(this.personalized, `${this.artwork.id}.template`, 0)
      return get(this.artwork, `templates[${template}].layers`)
    },
    imgProps() {
      const { layer, artworkImg } = this
      const props = { x: 0, y: 0, width: layer.width, height: layer.height }
      const layerRatio = layer.width / layer.height
      if (artworkImg) {
        const imgRatio = artworkImg.width / artworkImg.height
        if (imgRatio < layerRatio) {
          props.width = props.height * imgRatio
          props.x = (layer.width - props.width) / 2
        } else if (imgRatio > layerRatio) {
          props.height = props.width / imgRatio
        }
      }
      return props
    },
    printAreaConfig() {
      const { layer } = this
      var config = pick(layer, [
        'x',
        'y',
        'width',
        'height',
        'scaleX',
        'scaleY',
        'rotation',
        'skewX',
        'skewY',
      ])
      var scaleX = get(config, 'scaleX', 1)
      var scaleY = get(config, 'scaleX', 1)
      config.width = config.width * scaleX
      config.height = config.height * scaleY
      config.scaleX = this.scaleDom;
      config.scaleY = this.scaleDom;
      this.$emit('setPrintAreaConfig', config);
      return config
    },
    clippingMaskConfig() {
      const { layer, printAreaConfig } = this
      const config = { ...(layer.clippingMask || {}) }
      if (
        !layer.clippingMaskEnable ||
        typeof layer.clippingMask === 'undefined'
      ) {
        config.x = 0
        config.y = 0
        config.width = layer.width
        config.height = layer.height
      }
      var scaleX = get(layer, 'scaleX', 1)
      var scaleY = get(layer, 'scaleY', 1)
      return {
        x: 0,
        y: 0,
        width: printAreaConfig.width,
        height: printAreaConfig.height,
        clipFunc: ctx => {
          ctx.rect(
            config.x * scaleX - this.printAreaOffsetX,
            config.y * scaleY,
            config.width * scaleX,
            config.height * scaleY
          )
        }
      }
    },
    artworkPreview() {
      const { artworkPreviews, artwork } = this
      if (artwork) {
        return get(artworkPreviews, artwork.id)
      }
      return null
    },
    artworkLoading() {
      const { loadings, artwork } = this
      if (artwork) {
        return map(get(loadings, artwork.id, {})).some(
          loading => loading === true
        )
      }
      return false
    },
    artworkWidth() {
      const { artwork, printAreaConfig } = this
      var artworkRatio = artwork.width / artwork.height
      var printAreaRatio = printAreaConfig.width / printAreaConfig.height
      if (artworkRatio >= printAreaRatio) {
        this.$emit('setArtworkWidth', printAreaConfig.width);
        return printAreaConfig.width
      } else {
        this.printAreaOffsetX =
          (printAreaConfig.width - printAreaConfig.height * artworkRatio) / 2
        this.$emit('setArtworkWidth', printAreaConfig.height * artworkRatio);
        return printAreaConfig.height * artworkRatio
      }
    }
  },
  methods: {
    ...mapMutations(['setRatios']),
    updatePreview() {
      const { artwork, artworkPreviews } = this
      if (!artwork) {
        return
      }
      const img = new window.Image()
      const artworkPreview = get(artworkPreviews, artwork.id)
      img.onload = () => {
        this.artworkImg = img
      }
      img.src = artworkPreview
    }
  },
  watch: {
    artworkPreviews() {
      this.updatePreview()
    },
    artworkLoading(loading) {
      this.$emit('loading', loading)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PreviewArtwork/PrintAreaPreview.vue